module.exports = __webpack_public_path__ + "static/media/widget-three.5adae23b.png";